import '../../../node_modules/flickity/css/flickity.css';
import '../../styles/collection.scss';
import '../../styles/flickity-page-dots.scss';
import '../../styles/top-messaging.scss';

import '../snippets/product-grid-item';
import io from '../utils/intersection-observer';
var Ajaxinate = require("exports-loader?Ajaxinate!./../utils/ajaxinate.js");


document.addEventListener("DOMContentLoaded", () => {
  var endlessScroll = new Ajaxinate({
    callback: () => {

      document.querySelectorAll('.AjaxinateLoop img[defer]:not([deferred])').forEach(el => {
        if(Modernizr.touchevents && el.dataset.isHoverimage) {
          return;
        } else {
          io.observe(el);
        }
      });
    }
  });
});
